import React, { useState } from 'react';
import { XIcon, FileDownIcon } from 'lucide-react';
import DateRangePicker from '../common/DateRangePicker';
import MultiSelect from '../common/MultiSelect';
interface ExportModalProps {
  onClose: () => void;
}
const ExportModal: React.FC<ExportModalProps> = ({
  onClose
}) => {
  const [filters, setFilters] = useState({
    dateRange: {
      start: '',
      end: ''
    },
    airlineCodes: []
  });
  const [errors, setErrors] = useState({
    dateRange: '',
    airlineCodes: ''
  });
  const handleFilterChange = (key: string, value: any) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
    // Clear error when user selects a value
    if (errors[key]) {
      setErrors(prev => ({
        ...prev,
        [key]: ''
      }));
    }
  };
  const handleExport = () => {
    // Validate inputs
    const newErrors: {
      dateRange?: string;
      airlineCodes?: string;
    } = {};
    if (!filters.dateRange.start || !filters.dateRange.end) {
      newErrors.dateRange = 'Please select a date range';
    }
    if (filters.airlineCodes.length === 0) {
      newErrors.airlineCodes = 'Please select at least one airline';
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(prev => ({
        ...prev,
        ...newErrors
      }));
      return;
    }
    // Proceed with export
    console.log('Exporting with filters:', filters);
    // Simulate export process
    setTimeout(() => {
      onClose();
      // You would typically trigger a download here
    }, 1000);
  };
  return <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center" data-id="element-297">
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-298">
        <div className="flex items-start justify-between p-4 border-b border-gray-200" data-id="element-299">
          <h3 className="text-xl font-semibold text-gray-900" data-id="element-300">
            Export Ticket Data
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500 focus:outline-none" aria-label="Close" data-id="element-301">
            <XIcon className="h-6 w-6" data-id="element-302" />
          </button>
        </div>
        <div className="p-6 space-y-6" data-id="element-303">
          <div data-id="element-304">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-305">
              Issue Date Range <span className="text-red-500" data-id="element-306">*</span>
            </label>
            <DateRangePicker value={filters.dateRange} onChange={value => handleFilterChange('dateRange', value)} data-id="element-307" />
            {errors.dateRange && <p className="mt-1 text-sm text-red-600" data-id="element-308">{errors.dateRange}</p>}
          </div>
          <div data-id="element-309">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-310">
              Airline Codes <span className="text-red-500" data-id="element-311">*</span>
            </label>
            <MultiSelect options={[{
            value: 'SQ',
            label: 'SQ - Singapore Airlines'
          }, {
            value: 'QR',
            label: 'QR - Qatar Airways'
          }, {
            value: 'EK',
            label: 'EK - Emirates'
          }, {
            value: 'CX',
            label: 'CX - Cathay Pacific'
          }, {
            value: 'MH',
            label: 'MH - Malaysia Airlines'
          }]} value={filters.airlineCodes} onChange={value => handleFilterChange('airlineCodes', value)} placeholder="Select airlines..." data-id="element-312" />
            {errors.airlineCodes && <p className="mt-1 text-sm text-red-600" data-id="element-313">{errors.airlineCodes}</p>}
          </div>
          <div className="bg-gray-50 p-4 rounded-md" data-id="element-314">
            <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-315">
              Export Format
            </h4>
            <p className="text-sm text-gray-500" data-id="element-316">
              Exported CSV will group tickets by airline and show subtotals and
              grand totals.
            </p>
          </div>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200" data-id="element-317">
          <button type="button" className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm ${!filters.dateRange.start || !filters.dateRange.end || filters.airlineCodes.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`} onClick={handleExport} disabled={!filters.dateRange.start || !filters.dateRange.end || filters.airlineCodes.length === 0} data-id="element-318">
            <FileDownIcon className="h-5 w-5 mr-1" data-id="element-319" />
            Export
          </button>
          <button type="button" onClick={onClose} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-320">
            Cancel
          </button>
        </div>
      </div>
    </div>;
};
export default ExportModal;